export default __webpack_public_path__ + "static/O0081-14741ee88a13978204980168322e1f7c.png";